import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DataServer } from "../../../../sensorconfig.axios";

interface AverageUseState {
  AverageUse: {
    load: boolean;
    data: [];
  };
}

export const AverageUseSlice = createSlice({
  name: "AverageUse",
  initialState: {
    AverageUse: {
      load: false,
      data: [],
    },
  } as AverageUseState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAverageUse.pending, (state) => {
        state.AverageUse.load = true;
      })
      .addCase(getAverageUse.fulfilled, (state, action) => {
        state.AverageUse.data = action.payload;
        state.AverageUse.load = false;
      })
      .addCase(getAverageUse.rejected, (state) => {
        state.AverageUse.load = false;
      })
      .addCase(getOperatorAverageUseOverTime.pending, (state) => {
        state.AverageUse.load = true;
      })
      .addCase(getOperatorAverageUseOverTime.fulfilled, (state, action) => {
        state.AverageUse.data = action.payload;
        state.AverageUse.load = false;
      })
      .addCase(getOperatorAverageUseOverTime.rejected, (state) => {
        state.AverageUse.load = false;
      });
  },
});

export default AverageUseSlice.reducer;

export const getAverageUse = createAsyncThunk(
  "AverageUse/getAverageUse",
  async (param: any) => {
    try {
      var data: any; 
      if(param.apiParam.operator_id === "all"){
        data = await DataServer.get("/api/management/mheSummary/v1/getAverageUse?warehouse_id=" + param.apiParam.warehouse_id + "&mhe_id=" + param.apiParam.mhe_id + "&duration=" + param.apiParam.duration);
      } else {
        data = await DataServer.get("/api/management/mheSummary/v1/getAverageUse?warehouse_id=" + param.apiParam.warehouse_id + "&mhe_id=" + param.apiParam.mhe_id + "&duration=" + param.apiParam.duration + "&operator_id=" + param.apiParam.operator_id);
      }
      return data.data;
    } catch (error) {
      return error;
    }
  }
);

export const getOperatorAverageUseOverTime = createAsyncThunk(
  "AverageUse/getOperatorAverageUseOverTime",
  async (param: any) => {
    try {
      var data = await DataServer.get("/api/management/operatorSummary/v1/getOperatorAverageUseOverTime?warehouse_id=" + param.apiParam.warehouse_id + "&company_id=" + param.apiParam.company_id + "&duration=" + param.apiParam.duration + "&operator_id=" + param.apiParam.operator_id);
      
      return data.data;
    } catch (error) {
      return error;
    }
  }
);
